import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username } from '../internal.js'

const credentialTypes = [
  username,
  password,
  'api-username',
  'api-password',
] as const

export type echsCredType = (typeof credentialTypes)[number]
export const echsDocumentTypes = [
  'invoice',
  'other',
  'proof-of-delivery',
  'signed-bol',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const echs: CarrierDef<echsCredType> = {
  name: 'Echo Global Logistics',
  scac: 'echs',
  credentialTypes,
  legacyCredMap: [
    ['api-username', 'username'],
    ['api-password', 'password'],
  ],
  engineLayers: ['rating', 'bol', 'pickup', 'documents', 'tracking'],
  documentTypes: echsDocumentTypes,
  credentialConfig: {
    username: { hideFromFreightview: true },
    password: { hideFromFreightview: true },
  },
}
